var _g, _g2, _path, _path2, _rect, _g3, _g4, _g5, _g6, _g7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ha0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#ha-filter0_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 18,
    fill: "#053668"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#ha-filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.64003 14.2159C6.35414 13.149 6.98731 12.0523 8.05424 11.7665L38.9639 3.48424C40.0308 3.19836 41.1275 3.83152 41.4134 4.89846L52.2838 45.4673C52.5696 46.5343 51.9365 47.6309 50.8695 47.9168L17.0621 56.9755C15.9952 57.2614 14.8985 56.6282 14.6126 55.5613L11.3552 43.4043C11.2866 43.1482 11.3225 42.8752 11.4551 42.6455L13.1622 39.6887C13.2948 39.459 13.3308 39.1861 13.2621 38.9299L6.64003 14.2159Z",
    fill: "#073459"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41542 13.5089C5.12953 12.442 5.7627 11.3453 6.82963 11.0594L37.7393 2.77721C38.8062 2.49133 39.9029 3.12449 40.1887 4.19142L51.0591 44.7603C51.345 45.8272 50.7119 46.9239 49.6449 47.2098L15.8375 56.2685C14.7706 56.5543 13.6739 55.9212 13.388 54.8543L10.1306 42.6973C10.062 42.4411 10.0979 42.1682 10.2305 41.9385L11.9376 38.9817C12.0702 38.752 12.1061 38.4791 12.0375 38.2229L5.41542 13.5089Z",
    fill: "#1E95F8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76172 10.5417L37.7395 2.77718C38.8064 2.49129 39.9031 3.12446 40.189 4.19139L51.0594 44.7603C51.3453 45.8272 50.7121 46.9239 49.6452 47.2098L20.6674 54.9743L8.76172 10.5417Z",
    fill: "url(#ha-paint0_linear)",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.82963 11.0594C5.76265 11.3453 5.12953 12.442 5.41542 13.5089L12.0375 38.2229C12.1062 38.4791 12.0702 38.752 11.9377 38.9817L10.2304 41.9385C10.0979 42.1682 10.062 42.4411 10.1306 42.6973L13.388 54.8543C13.6739 55.9212 14.7706 56.5544 15.8375 56.2685L20.6672 54.9744L8.76148 10.5418L6.82963 11.0594Z",
    fill: "url(#ha-paint1_linear)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 7.7959,
    y: 10.8005,
    width: 1,
    height: 46,
    transform: "rotate(-15 7.7959 10.8005)",
    fill: "#053668"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5044 14.3421C17.4275 13.7952 17.8086 13.2895 18.3555 13.2126L48.0635 9.03744C48.6105 8.96058 49.1161 9.34163 49.193 9.88854L54.7599 49.4993C54.8368 50.0462 54.4557 50.5518 53.9088 50.6287L24.2008 54.8039C23.6539 54.8808 23.1482 54.4997 23.0713 53.9528L17.5044 14.3421Z",
    fill: "#F3F5F4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2359 12.5008C16.159 11.9539 16.54 11.4482 17.0869 11.3713L46.795 7.19613C47.3419 7.11927 47.8476 7.50032 47.9244 8.04723L53.4914 47.658C53.5682 48.2049 53.1872 48.7105 52.6403 48.7874L22.9322 52.9626C22.3853 53.0394 21.8796 52.6584 21.8028 52.1115L16.2359 12.5008Z",
    fill: "#FEFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2359 12.5008C16.159 11.9539 16.54 11.4482 17.0869 11.3713L46.795 7.19613C47.3419 7.11927 47.8476 7.50032 47.9244 8.04723L53.4914 47.658C53.5682 48.2049 53.1872 48.7105 52.6403 48.7874L22.9322 52.9626C22.3853 53.0394 21.8796 52.6584 21.8028 52.1115L16.2359 12.5008Z",
    fill: "url(#ha-paint2_linear)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.4671,
    cy: 40.9882,
    r: 6,
    transform: "rotate(-8 43.4671 40.9882)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.4671,
    cy: 40.9882,
    r: 6,
    transform: "rotate(-8 43.4671 40.9882)",
    stroke: "#FD4E4E",
    strokeWidth: 2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8179 45.8276L47.113 36.1467",
    stroke: "#FD4E4E",
    strokeWidth: 2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3008 19.5723L42.1257 17.0677",
    stroke: "#0F2342",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8574 23.5334L42.6823 21.029L42.2475 21.0894",
    stroke: "#0F2342",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4141 27.4944L43.2389 24.9893",
    stroke: "#0F2342",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9707 31.4556L35.8734 30.0638",
    stroke: "#0F2342",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ha-filter0_f",
    x: -12,
    y: -12,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ha-filter1_f",
    x: 3.57129,
    y: 0.415527,
    width: 51.781,
    height: 59.6285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 16.9941,
    y: 8.52759,
    width: 39.2752,
    height: 47.7862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 15.7256,
    y: 6.68628,
    width: 39.2752,
    height: 47.7862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 33.4658,
    y: 31.9873,
    width: 20.0017,
    height: 20.0017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.137255 0 0 0 0 0.258824 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 36.0195,
    y: 33.5449,
    width: 14.8924,
    height: 16.8846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.137255 0 0 0 0 0.258824 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ha-paint0_linear",
    x1: 20.6674,
    y1: 54.9743,
    x2: 39.6713,
    y2: 2.25954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ha-paint1_linear",
    x1: 2,
    y1: 12.3535,
    x2: 8.76148,
    y2: 10.5418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ha-paint2_linear",
    x1: 16.0986,
    y1: 11.5102,
    x2: 55.312,
    y2: 46.7806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ha0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectFolder);
export default __webpack_public_path__ + "static/media/reject-folder.a8a3ee35.svg";
export { ForwardRef as ReactComponent };